import {
	collection,
	getDocs
}
from "firebase/firestore";

import { db }
from "../firebase/firebaseConfig";

const generarCronogramaRuta =
async ({

	userId,

	horasSemana,

	diasRestantes
}) => {

	const temasSnap =
	await getDocs(
		collection(
			db,
			"materias_temas"
		)
	);

const temasPrioritarios =
	temasSnap.docs
		.map(
			d => d.data()
		)
		.slice(0, 200);

	const semanas =
		Math.max(
			1,
			Math.ceil(
				diasRestantes / 7
			)
		);

	const temasPorSemana =
		Math.max(
			1,
			Math.ceil(
				temasPrioritarios.length /
				semanas
			)
		);

	const cronograma = [];

	for (
		let semana = 1;
		semana <= semanas;
		semana++
	) {

		const inicio =
			(semana - 1) *
			temasPorSemana;

		const fin =
			inicio +
			temasPorSemana;

		cronograma.push({

			semana,

			horas:
				horasSemana,

			temas:
				temasPrioritarios
					.slice(
						inicio,
						fin
					)
					.map(
	t => ({
		temaId: t.ID,
		nombre: t.Tema
	})
)
		});
	}

	return cronograma;
};

export default
	generarCronogramaRuta;